import { callApi } from "./api.service";

//Define the function to add celebrity to cart(Token required).
export const AddToCart = async (
  item_id: string,
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/cart/add-item?entity_id=${item_id}`;
  return await callApi(endpoint, "POST", true, getToken);
};

//Define the function to remove celebrity from cart(Token required).
export const RemoveFromCart = async (
  user_id: string,
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/cart/remove-item?entity_id=${user_id}`;
  return await callApi(endpoint, "DELETE", true, getToken);
};

//Define the function to get items in cart(Token required).
export const GetCartItems = async (getToken: () => Promise<string | null>) => {
  const endpoint = `/api/cart/get-items`;
  return await callApi(endpoint, "GET", true, getToken);
};

export const CreateCheckoutSession = async (
  data: any,
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/payment/create-checkout-session`;
  return await callApi(endpoint, "POST", true, getToken, data);
};

export const GetCheckoutSession = async (
  data:any,
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/payment/get-checkout-session`;
  return await callApi(endpoint, "POST", true, getToken, data);
};

export const UpdateCheckoutSession = async (
  data:any,
  getToken: () => Promise<string | null>
) => {
  const endpoint = `/api/payment/update-checkout-session`;
  return await callApi(endpoint, "POST", true, getToken, data);
};
